export const BASE_CLASS_NAME = 'mt-PublishMyAdWithPlate-stepFormSellerPlate'

export const fieldsToCheck = [
  'make',
  'bodyType',
  'doors',
  'fuelType',
  'fuelTypeId',
  'model',
  'transmissionType',
  'transmissionTypeId',
  'version',
  'plateRegistrationYear'
]
